import { receivingCreateRequestStateName } from './createRequest/createRequest.state';
import { receivingConfirmRequestStateName } from './confirmRequest/confirmRequest.state';
import { receivingSubmitRequestStateName } from './submitRequest/submitRequest.state';
import { successfulSubmitStateName } from './successfulSubmit/successfulSubmit.state';
import { DataParser } from '@fino/ng1-filter/src/parser';

import { FeatureFlagNames } from '../../../../common/featureFlags/featureFlags';

export const ReceivingCreatedSuccessState = successfulSubmitStateName;

export const ReceivingStates = {
  create: receivingCreateRequestStateName,
  confirm: receivingConfirmRequestStateName,
  submit: receivingSubmitRequestStateName,
};

export const ReceivingKwhTypes = {
  WITH_GUIDANCE: 'withGuidance',
  ONLINE: 'online',
  WITHOUT_GUIDANCE: 'withoutGuidance',
};

export const ReceivingDataModifiers = [
  {
    type: DataParser.modifierTypes.DATE,
    properties: [
      'birthday',
      'accountswitchSpecificDate',
      'closeAccount',
      'refuseDebitsAndDeposits',
    ],
  },
  {
    type: DataParser.modifierTypes.IBAN,
    properties: ['newIban', 'oldIban'],
    args: [true],
  },
  {
    type: DataParser.modifierTypes.ARRAY,
    properties: ['informAllButBlacklistedPaymentPartners'],
  },
];

/**
 * Sets the validation rules for the submit types.
 * TODO (AV) Refactor this to use the config.json-files
 * for each customization.
 */
export const ReceivingSubmitValidationRules = {
  default: {
    [ReceivingKwhTypes.WITH_GUIDANCE]: {
      advice: {
        type: 'advice',
      },
      appointmentDate: {
        type: 'date',
      },
      emailAddress: {
        type: 'email',
      },
      footNote: {
        type: 'footNote',
      },
    },
    [ReceivingKwhTypes.ONLINE]: {
      emailAddress: {
        type: 'email',
        required: true,
      },
      mobileNumber: {
        type: 'text',
        required: true,
      },
      footNote: {
        type: 'footNote',
      },
    },
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {
      emailAddress: {
        type: 'email',
      },
      footNote: {
        type: 'footNote',
      },
    },
  },

  SMM: {
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {
      bankEmployeeEmailAddress: {
        type: 'email',
        hasInfo: true,
        requiredByFeature:
          FeatureFlagNames.FF_BANK_EMLOYEE_EMAIL_ADRESS_ON_WARRANT_STATE_REQUIRED,
      },
      emailAddress: {
        hasInfo: true,
        type: 'email',
      },
      footNote: {
        type: 'footNote',
      },
    },
  },

  RBAT: {
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {
      bankEmployeeEmailAddress: {
        type: 'email',
        hasInfo: true,
        requiredByFeature:
          FeatureFlagNames.FF_BANK_EMLOYEE_EMAIL_ADRESS_ON_WARRANT_STATE_REQUIRED,
      },
      emailAddress: {
        hasInfo: true,
        type: 'email',
      },
      footNote: {
        type: 'footNote',
      },
    },
  },

  // Custom fields and validation rules for santander
  santander: {
    [ReceivingKwhTypes.WITH_GUIDANCE]: {
      advice: {
        type: 'advice',
      },
      emailAddress: {
        type: 'email',
        requiredUnless: 'withoutEmail',
        hideWhen: 'withoutEmail',
      },
      withoutEmail: {
        type: 'checkbox',
      },
      footNote: {
        type: 'footNote',
        hideWhen: 'withoutEmail',
      },
    },
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {
      emailAddress: {
        type: 'email',
        requiredUnless: 'withoutEmail',
        hideWhen: 'withoutEmail',
      },
      withoutEmail: {
        type: 'checkbox',
      },
      footNote: {
        type: 'footNote',
        hideWhen: 'withoutEmail',
      },
    },
  },

  // Custom fields and validation rules for volkswagenbank
  volkswagenbank: {
    [ReceivingKwhTypes.ONLINE]: {
      emailAddress: {
        type: 'email',
      },
      mobileNumber: {
        type: 'text',
      },
      footNote: {
        type: 'footNote',
      },
    },
  },

  'fiducia-light': {
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {},
  },

  klarnabank: {
    [ReceivingKwhTypes.WITHOUT_GUIDANCE]: {
      emailAddress: {
        type: 'email',
        required: true,
      },
      footNote: {
        type: 'footNote',
      },
    },
  },
};
